import React from "react";
import { AppBar, Toolbar, Typography, Button, IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import colors from "../theme/Colors";
import { toast } from "react-toastify";

const Navbar = ({ title = "Page Title" }) => {
  const handleLogout = () => {
    localStorage.removeItem('user');
    window.location.reload();
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: colors.primary,
        width: "100%",
        textAlign:'center',
        boxSizing: "border-box",
       
      }}
    >
      <Toolbar>
        <Typography variant="h4" color={'black'} sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        <IconButton
          color="inherit"
          onClick={handleLogout}
          sx={{ display: { xs: "none", sm: "flex" } }}
        >
          <LogoutIcon />
        </IconButton>
        <Button
          variant="outlined"
          color="inherit"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{ display: { xs: "flex", sm: "none" } }}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
